import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    borderRadius: "15px",
    // [theme.breakpoints.down("sm")]: {
    //   width: "80%",
    // },
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "left",
  },
  fileInput: {
    width: "100%",
    margin: "8px",
    display: "flex",
    alignSelf: "center",
    justifySelf: "center",
  },
  buttonSubmit: {
    margin: "0 8px 10px 8px",
    // borderRadius: 15,
  },
}));
